import type { GameLogEntry } from '@shared/game/types';
import { logIcon } from '../lib/format';
import { Icon, type IconName } from './Icon';

interface LogPanelProps {
  log: GameLogEntry[];
  compact?: boolean;
}

export function LogPanel({ log, compact = false }: LogPanelProps) {
  const entries = [...log].slice(-14).reverse();
  return (
    <section className={`log-panel ${compact ? 'log-panel--compact' : ''}`}>
      <div className="panel-heading">
        <span className="eyebrow">Registro de señales</span>
        <span className="panel-heading__hint">Últimos eventos</span>
      </div>
      <div className="log-list" role="log" aria-live="polite">
        {entries.length === 0 && <p className="muted small">Todavía no ha pasado nada.</p>}
        {entries.map((entry) => (
          <div key={entry.id} className={`log-entry log-entry--${entry.kind}`}>
            <span className={`log-entry__icon ${entry.color ? `log-entry__icon--${entry.color}` : ''}`}>
              <Icon name={logIcon(entry.kind) as IconName} size={13} />
            </span>
            <span className="log-entry__text">{entry.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
